/**
 * Models the Final Beneficiary data that is related to a Legal Entity
 * Note that the Final Beneficiary is not defined in the case that
 * the CORE service returns an already existing legal entity profile
 * (we avoid updating pre-existing final beneficiary data)
 */
type FinalBeneficiary = {
  firstName: string;
  lastName: string;
  idType: string; // N, P, J
  id: string;
  sharePercentage: number; // range 10 - 100
  birthdate: string;
  nationalityId: string;
  nationality: string;
  birthPlaceId: string;
  birthPlace: string;
  occupation: string;
  occupationName: string;
  companyRole: string;
  phone1: string;
  phone2: string;
  addressDetail: string;
  countryId: string;
  country: string;
  stateId: string;
  state: string;
  cityId: string;
  city: string;
  townshipId: string;
  township: string;
  economicActivity: string;
  economicActivityName: string;
};

export function makeEmptyFinalBeneficiary(): FinalBeneficiary {
  return {
    firstName: '',
    lastName: '',
    idType: 'N',
    id: '',
    sharePercentage: 10,
    birthdate: '',
    nationalityId: '',
    nationality: '',
    birthPlaceId: '',
    birthPlace: '',
    occupation: '',
    occupationName: '',
    companyRole: '',
    phone1: '',
    phone2: '',
    addressDetail: '',
    countryId: '',
    country: '',
    stateId: '',
    state: '',
    cityId: '',
    city: '',
    townshipId: '',
    township: '',
    economicActivity: '',
    economicActivityName: '',
  };
}

export default FinalBeneficiary;
